export const SET_CART_PRICE = 'SET_CART_PRICE';

export const setCartPrice = (payload) => {
  return {
    type: SET_CART_PRICE,
    payload,
  };
};
